/**
 * FILE: index.js
 * PURPOSE: The "Starting Gate" for the app.
 * WHAT IT DOES: It tells the computer exactly where to put the application on your screen when you first open the webpage.
 * LAYMAN SUMMARY: It's the "Go" button that starts the engine.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { HelmetProvider } from 'react-helmet-async';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';

const GOOGLE_CLIENT_ID = "15404832880-jebj2kfaces5ttmi5e4nfhv5sdek9em8.apps.googleusercontent.com";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <App />
      </GoogleOAuthProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// PWA: Register the Service Worker (which is now a Kill Switch to clear stale caches)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(reg => {
        console.log('[PWA] Service Worker registered (Kill Switch Active)', reg);
      })
      .catch(err => {
        // Silencing AbortError which occurs when the SW is cleared by Nginx mid-registration
        if (err.name === 'AbortError') return;
        console.log('[PWA] Service Worker registration failed', err);
      });
  });
}
